function TicketType () {
  function filter (value) {
    switch (value) {
      case 'printed':
        return 'Impresso'

      case 'digital':
        return 'Digital'

      default:
        return 'Desconhecido'
    }
  }

  return {
    filter
  }
}

export default TicketType
